import $ from 'jquery';


let allChecked = false;
const handleCheckboxChange = () => {
  allChecked = true;
  $('#js_offer_accept_checkboxes input.js_accept_checkbox').each(function () {
    allChecked = allChecked && $(this).is(':checked');
  });

  $('#js_offer_accept_checkboxes #js_submit_button').prop('disabled', !allChecked);
};

export default () => {
  $(document).ready(() => {
    if ($('#js_offer_accept_checkboxes').length === 0) {
      return;
    }

    $('#js_offer_accept_checkboxes').on('ifChanged', 'input.js_accept_checkbox', handleCheckboxChange);
    handleCheckboxChange();
  });
};
